import React, { useEffect, useState, useMemo } from 'react';
import { Dashboard } from './components/Dashboard';
import { MobileDashboard } from './components/MobileDashboard';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { isMobileScreen } from '@apply/ui';
import { DrawApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { useAuthenticationStore } from '../../../state/authenticationStore';
import { useNavigate } from 'react-router';
import { GenericAlertPopup } from '@apply/components';

export const GeneralContractorDashboard: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const [dashboardDrawBudgets, set_dashboardDrawBudgets] = useState<IDashboardDrawBudget[] | undefined>(undefined);
    const [loading, set_loading] = useState<boolean>(true);
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);
    const navigate = useNavigate();

    const drawApi = useMemo(() => new DrawApi.DrawApi(applicationInsights), [applicationInsights]);

    const loadApplicationData = async () => {
        if (selectedAuthorizedDrawUserEntity?.borrowerEntityId != undefined) {
            const response = await drawApi.dashboardDrawBudgetsGC({
                borrowerEntityId: selectedAuthorizedDrawUserEntity?.borrowerEntityId,
                assigningUserId: selectedAuthorizedDrawUserEntity?.ownerUserId,
            });
            if (response.statusCode !== 200) {
                return;
            }
            const result = response.result;
            set_dashboardDrawBudgets(result);
        } else {
            GenericAlertPopup({
                title: 'Error',
                children: 'Failed to load draw data.  Please try again later',
                width: '350px',
            });
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            loadApplicationData();
        };
        fetchData();
        set_loading(false);
    }, []);

    useEffect(() => {
        // Redirect to entity selection if no entity is selected
        if (!selectedAuthorizedDrawUserEntity) {
            navigate('/entity-selection');
        }
    }, [selectedAuthorizedDrawUserEntity, navigate]);

    if (!selectedAuthorizedDrawUserEntity) {
        return (
            <div className='overlay'>
                <div className='overlay__inner'>
                    <div className='overlay__content'>
                        <span className='spinner'></span>
                        <span className='spinner-text'>Loading</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {mobileScreen && (
                <MobileDashboard
                    dashboardDrawBudgets={dashboardDrawBudgets}
                    loading={loading}
                />
            )}
            {!mobileScreen && (
                <Dashboard
                    dashboardDrawBudgets={dashboardDrawBudgets}
                    loading={loading}
                />
            )}
        </>
    );
};
